import { z } from 'zod';

import { AUDIT_ACTOR_KINDS } from './constants.js';

export const auditActorKindSchema = z.enum(AUDIT_ACTOR_KINDS);

export const auditFilterQuery = z.object({
  orgId: z.string().uuid().optional(),
  actorUserId: z.string().uuid().optional(),
  actorKind: auditActorKindSchema.optional(),
  action: z.string().max(80).optional(),
  entityType: z.string().max(60).optional(),
  fromDate: z.string().datetime().optional(),
  toDate: z.string().datetime().optional(),
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(200).default(50),
});
export type AuditFilterQuery = z.infer<typeof auditFilterQuery>;

export const auditEntry = z.object({
  id: z.string().uuid(),
  orgId: z.string().uuid().nullable(),
  actorUserId: z.string().uuid().nullable(),
  actorKind: auditActorKindSchema,
  action: z.string(),
  entityType: z.string(),
  entityId: z.string().uuid().nullable(),
  metadata: z.record(z.unknown()),
  ip: z.string().nullable(),
  userAgent: z.string().nullable(),
  createdAt: z.string().datetime(),
});
export type AuditEntry = z.infer<typeof auditEntry>;
